/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, postDownload, tokenPost} from "./ajax";

const supplier = {
  /**
   *  AJAX-获取供应商列表
   *  @param search
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listSuppliers(search,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SUPPLIERS,
      {
        keys: search.id,
        materialId: search.materialId,
        isStop: search.statusId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-导出采购价
   * @param success
   * @param isLoadingExplicit
   * @param errorHandler
   */
  exportMaterial(success, isLoadingExplicit, errorHandler){
    postDownload.bind(this)(
      url.EXPORT_MATERIAL_SUPPLIER,
      {},
      success,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-启用/停用供应商
   * @param num
   * @param flag
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  stop(num, flag, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.STOP,
      {
        num: num,
        flag: flag,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加供应商
   *  @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_SUPPLIERS,
      {
        supplierName : info.name,
        supplierNum : info.num,
        contactName : info.contactName,
        contactMobileno : info.mobileNo,
        spellCode : info.spellCode,
        transitDay: info.transitDay,
        purchaseFrequency: info.purchaseFrequency,
        settleType: info.typeId
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改供应商
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_SUPPLIER,
      {
        supplierName : info.supplierName,
        supplierNum : info.supplierNum,
        contactName : info.contactName,
        contactMobileno : info.mobileNo,
        spellCode : info.spellCode,
        isStop: info.isStop,
        transitDay: info.transitDay,
        purchaseFrequency: info.purchaseFrequency,
        settleType: info.typeId
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取供应商详情
   * @param num
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquire(num, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_SUPPLIER,
      {
        num: num,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加货品
   * @param materialId
   * @param unitPrice
   * @param supplierId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addMaterial(supplierId,materialId,unitPrice, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_MATERIAL_SUPPLIER,
      {
        materialId: materialId,
        unitPrice: unitPrice,
        supplierId: supplierId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除货品
   * @param materialId
   * @param supplierId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteMaterial(supplierId,materialId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_MATERIAL_SUPPLIER,
      {
        materialId: materialId,
        supplierId: supplierId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default supplier;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-supplier.js